import type { FaireProductEntity } from "../../entity_types/product";

export const p_davsqcw6f4: FaireProductEntity = {
  token: "p_davsqcw6f4",
  type: "product",
  name: "Natural Acacia Wood Kitchen Utensil Set",
  brandToken: "b_h448y6kg3f",
  brandName: "Smile Boutiques",
  imageUrl:
    "https://cdn.faire.com/fastly/f508091e2435d4b1c8f5aa82c2edc45d62e25e2fcac6a7017edc4ebe16e9115a.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e6c8b666cd4019a2155aaafbd0433e70b1104c75739df14c3ac6ee50e403b49.webp",
    "https://cdn.faire.com/fastly/10ae198a82e29238dc67703f6a93a8783fea13c296aae4bfa2d5f4f892373205.webp",
    "https://cdn.faire.com/fastly/e2c66605f836ed74cecd8d5f35677b11887bef5e865f0442f496e4a9a6c27722.webp",
    "https://cdn.faire.com/fastly/6e9f35ea7f2f52ebe5ac2a0cfff9e2907464bf42a6551c6c5319a5cf8852f0d5.webp",
  ],
  priceDollars: 13.5,
  description:
    'These beautifully crafted luxury utensils are made with acacia wood which have proven to be durable. This 5-piece set is attractively designed and very useful in every kitchen. Lightweight and ideal for cooking with non-stick cookware, these utensils are comfortable and will not melt away.\n\n• Ideal for cooking with nonstick cookware\n• Handles are designed to feel comfortable in the hand\n• Acacia is durable hard wood, with an attractive finish\n• Hand wash only and thoroughly dry\n• Occasionally rub with a food-safe mineral oil to keep wood from drying out\n• 5 pieces\n\n𝐒𝐞𝐭 𝐈𝐧𝐜𝐥𝐮𝐝𝐞𝐬:\n\n• Slotted Spatula 12"\n• Strainer Spoon 11.2"\n• Soup Ladle 10.7"\n• Serving Spoon 10.5"\n• Salad Fork 10.5"',
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:32.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
